export default __webpack_public_path__ + "static/media/rnr-sports-table-6.ee834671.webp";